import { ReactNode } from 'react';

import TabInvite from 'components/InvitePersons/TabInvite';

import OnboardingTabActions from './OnboardingTabActions';

type OnboardingTabHeaderProps = {
  title: string | ReactNode;
  subTitle?: string | ReactNode;
  onSave?: () => void;
  onCancel?: () => void;
  isActionsDisabled?: boolean;
};

const OnboardingTabHeader: React.FC<OnboardingTabHeaderProps> = ({
  title,
  subTitle,
  onSave,
  onCancel,
  isActionsDisabled,
}) => {
  return (
    <div className="px-6 py-5 border-b border-gray-200 pb-5 flex items-center justify-between">
      <div>
        <p className="text-2xl font-semibold">{title}</p>
        {subTitle && <p className="text-secondary mt-1">{subTitle}</p>}
      </div>
      <div className="flex items-center gap-4">
        <TabInvite />
        <OnboardingTabActions
          onSave={onSave}
          onCancel={onCancel}
          isActionsDisabled={isActionsDisabled}
        />
      </div>
    </div>
  );
};

export default OnboardingTabHeader;
